import { render } from "./Scene_1.vue?vue&type=template&id=ad15575c"
import script from "./Scene_1.vue?vue&type=script&lang=js"
export * from "./Scene_1.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__